<template>
  <div id="g-recaptcha" class="g-recaptcha" :data-sitekey="sitekey"></div>
</template>

<script>
export default {
  data() {
    return {
      sitekey: "6Leng5oUAAAAAAUw2dly8s8SKQu-FIeQcnawC-vB", //"6Ldcg5oUAAAAAEyXCB9tHJnug47NE7ucVmvOggjF", //"6Leng5oUAAAAAAUw2dly8s8SKQu-FIeQcnawC-vB",
      widgetId: 0
    };
  },
  methods: {
    execute() {
      window.grecaptcha.execute(this.widgetId);
    },
    reset() {
      window.grecaptcha.reset(this.widgetId);
    },
    render() {
      console.log('a')
      if (window.grecaptcha) {
      console.log('b')
        this.widgetId = window.grecaptcha.render("g-recaptcha", {
          jsUrl: 'https://www.google.com/recaptcha/api.js?render=explicit', // default
          sitekey: this.sitekey,
          size: "invisible",
          // the callback executed when the user solve the recaptcha
          callback: response => {
            // emit an event called verify with the response as payload
            this.$emit("verify", response);
            // reset the recaptcha widget so you can execute it again
            this.reset();
          }
        });
      console.log('c')
      }
      console.log('d')
    }
  },
  mounted() {
    this.sitekey = process.env.VUE_APP_CAPTCHA;
    //console.log(process.env.VUE_APP_CAPTCHA);
    // render the recaptcha widget when the component is mounted
    this.render();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Auth/Recaptcha.vue